export const validationCode = {
  Success: 200,
  ForeignCountryLetter: 250,
  ZipCodeValidationFailed: 269,
  PageCountValidationFailed: 271,
  LargeLetterPageCountValidationFailed: 272,
  FoldTypeValidationFailed: 273,
  SenderAddressFieldValdationFailed: 275,
  FontIsNotEmbedded: 281,
  DuplicatesExists: 283,
  PageSizeValidationFailed: 290,
  PageOrientationValidationFailed: 291,
  PzuSheetCountValidationFailed: 292,
  StampAreaNotFree: 300,
  ProductionNoteAreaNotFree: 310,
  FrankingOnEnvelopePossible: 320,
  TextPatternNotFound: 404,
  UserHasNoPermission: 501,
  InvalidMetaTag: 504,
  XMP: 514,
  PdfFileEncrypted: 520,
  WhiteLineSerialSequenzeNotParseable : 691,
  WhiteLineColorModeNotParseable : 601,
  WhiteLinePrintModeNotParseable : 602,
  WhiteLineFoldTypeNotParseable : 603,
  WhiteLinePaperTypeNotParseable : 604,
  WhiteLineCustomMergeValueNotParseable : 605,
  WhiteLineCustomMergeIndexNotParseable : 606,
  WhiteLineCostCenterNotParseable : 607,
  WhiteLineMandantNotParseable : 608,
  WhiteLineUnkownKeyNameInclude : 609,
  WhiteLineMultipleZVVInclude : 610,
  // WhiteLine: 699,
  WhiteLineNotParsable: 699,
}
